import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    'fr': {
        yourApplications : 'Vos Applications',
        titleProg : 'Outils programmateur',
        titleHome : 'Vos Applications',
        dwnSetupFull : 'Télécharger le setup complet',
        dwnSetupFullProg : 'Télécharger le setup du programmateur USB',
        dwnSetupFullKiProg : 'Télécharger le setup du KiProg',
        updateProg : 'Mettre à jour votre programmateur',
        updateKiProg : 'Mettre à jour votre KiProg',
        download : 'Télécharger',
        downloadSoft : 'Télécharger le programme',
        installAndTest : 'Installer et tester le programmateur',
        toolsProg : 'Outils programmateur',
        installProg : 'Installation du programmateur',
        exit : 'Quitter',
        reloadTest : 'Relancer le test',
        system : 'Système',
        browser : 'Navigateur',
        application : 'Application',
        programmer : 'Programmateur',
        progUSB : 'Programmateur USB',
        progKiProg : 'Programmateur KiProg',
        plugProg : 'Branchez votre programmateur',
        whatDoYouWhat : 'Que voulez-vous faire ?',
        readAnTag : 'Lire un badge',
        readAnEtikronic : 'Lire un porte-clefs',
        readAnKiBolt : 'Lire une clé KiBolt',
        clickOnProg : "Cliquer sur le programmateur pour lancer l'installation",
        clickOnSoft : "Cliquer sur le fichier qui vient d'être téléchargé.<br>Demandez à votre administrateur réseau si l'installation bloque.",
        tools : 'Utilitaires',
        setupProg : 'Setup Programmateur USB',
        setupKiProg : 'Setup KiProg',
        serialgrave : 'N° de Badge',
        serialKiBolt : 'N° de KiBolt',
        putFobOnProg : 'Poser un badge ou une télécommande sur le programmateur',
        putEtikronicOnProg : 'Poser un porte-clef sur le programmateur',
        putKiBoltInProg : 'Insérer la clé KiBolt dans le KiProg',
        black : 'Noire',
        red : 'Rouge',
        green : 'Verte',
        grey : 'Grise',
        yellow : 'Jaune',
        blue : 'Bleue',
        purple : 'Violet',
        brown : 'Marron',
        lgbt : 'Bizarre',
        white : 'Blanc',
        step : 'Etape',
        next : 'Suivant'
    },
    'en': {
        yourApplications : 'Applications',
        titleProg : 'Programmer tools',
        titleHome : 'Your Applications',
        dwnSetupFull : 'Download the complete setup',
        dwnSetupFullProg : 'Download the setup of the USB programmer',
        dwnSetupFullKiProg : 'Download the setup of the KiProg',
        updateProg : 'Update your programmer',
        updateKiProg : 'Update your KiProg',
        download : 'Download',
        downloadSoft : 'Download the software',
        installAndTest : 'Install and test the programmer',
        toolsProg : 'Programmer tools',
        installProg : 'Installation of the key programmer',
        exit : 'Exit',
        reloadTest : 'Restart the test',
        system : 'System',
        browser : 'Browser',
        application : 'Application',
        programmer : 'Programmer',
        progUSB : 'Programmer USB',
        progKiProg : 'Programmer KiProg',
        plugProg : 'Please plug in your programmer',
        whatDoYouWhat : 'What do you want to do?',
        readAnTag : 'Read a fob or remote',
        readAnEtikronic : 'Read a Etiktronic',
        readAnKiBolt : 'Read a KiBolt',
        clickOnProg : "Click on the programmer to start the installation",
        clickOnSoft : "Click on the file you just downloaded.<br>Please contact your network administrator if you cannot complete the installation.",
        tools : 'Tools',
        setupProg : 'Setup USB Programmer',
        setupKiProg : 'Setup KiProg',
        serialgrave : 'No. of the fob',
        serialKiBolt : 'No. KiBolt',
        putFobOnProg : 'Please place a fob or a remote control on the programmer',
        putEtikronicOnProg : 'Please put a Etiktronic on the programmer',
        putKiBoltInProg : 'Please insert your KiBolt in the KiProg',
        black : 'Black',
        red : 'Red',
        green : 'Green',
        grey : 'Grey',
        yellow : 'Yellow',
        blue : 'Blue',
        purple : 'Purple',
        brown : 'Brown',
        lgbt : 'Strange',
        white : 'White',
        step : 'Step',
        next : 'Next'
    }
};

const i18n = new VueI18n({
    /*locale: 'fr', // set locale*/
    fallbackLocale: 'en', // set fallback locale
    messages, // set locale messages
});
let userLang = (navigator.language || navigator.userLanguage);
userLang = userLang.toLocaleLowerCase().substring(0, 2);
let blocale = userLang;
i18n.locale = blocale;

export default i18n;
